import React from 'react';
import ReactDOM from 'react-dom/client';
import './Style.scss';
import './index.css';
import App from './App';
import './Common.scss';
import reportWebVitals from './reportWebVitals';
import './App.css';
import './pdf.css';
import './Style.css';
// import './Style1406.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css/animate.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
